import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-d2106cae")
const _hoisted_1 = { class: "pdf-item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-break" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "自提点汇总", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "自提点"),
    /*#__PURE__*/_createElementVNode("th", null, "商品数量"),
    /*#__PURE__*/_createElementVNode("th", null, "金额"),
    /*#__PURE__*/_createElementVNode("th", null, "团长"),
    /*#__PURE__*/_createElementVNode("th", null, "自提点联系人"),
    /*#__PURE__*/_createElementVNode("th", null, "自提点电话"),
    /*#__PURE__*/_createElementVNode("th", null, "自提点地址")
  ])
], -1)
_popScopeId()

import { ref, onMounted } from "vue"

export default /*#__PURE__*/_defineComponent({
  props: {
	initData: Array
},
  setup(__props) {

const props = __props

const pdfItem = ref<any>([])
const renderPage = (data: any) => {
	let arr = data.map((item: any) => {
		let obj = {
			troupe: item['自提点'],
			count: item['商品数量'] ? item['商品数量'] : item['数量'],
			amount:  item['商品金额'],
			leader: item['团长'],
			locationPerson: item['自提点联系人'],
			phone: item['自提点电话'],
			address: item['自提点地址'],
		}
		return obj
	})
	pdfItem.value = uniqueArray(arr)
}
const uniqueArray = (arr: any) => {
	const uniqueArray = arr.reduce((acc: any, current: any) => {
		const existingItem = acc.find((item: any) => item.troupe === current.troupe);
		if (existingItem) {
			existingItem.count = Number(existingItem.count) + Number(current.count);
			let amount = Number(existingItem.amount) + Number(current.amount);
			existingItem.amount = amount.toFixed(2)
		} else {
			current.amount = Number(current.amount).toFixed(2)
			acc.push(current);
		}
		return acc;
	}, []);
	return uniqueArray
}

onMounted(() => {
	renderPage(props.initData)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("table", null, [
      _hoisted_4,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pdfItem.value, (value, idx) => {
          return (_openBlock(), _createElementBlock("tr", { key: idx }, [
            _createElementVNode("td", null, _toDisplayString(value.troupe), 1),
            _createElementVNode("td", null, _toDisplayString(value.count), 1),
            _createElementVNode("td", {
              class: _normalizeClass({ amount: value.amount < 99 })
            }, _toDisplayString(value.amount), 3),
            _createElementVNode("td", null, _toDisplayString(value.leader), 1),
            _createElementVNode("td", null, _toDisplayString(value.locationPerson), 1),
            _createElementVNode("td", null, _toDisplayString(value.phone), 1),
            _createElementVNode("td", null, _toDisplayString(value.address), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})